<p-dialog *ngIf="area"
          header="{{ ('WS_DIRECTORY.EXPERTISE_AREA.' + (area.id ? 'MODIFY_HEADER' : 'NEW_HEADER')) | translate }}"
          [(visible)]="display"

          [modal]="true"
          [draggable]="false"
          class="admin-dialog">
  <form [formGroup]="expertiseAreaForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.EXPERTISE_AREA.MODIFY.NAME' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <wsd-extended-input [control]="expertiseAreaForm.get('name')">
              <input pInputText formControlName="name">
            </wsd-extended-input>
          </div>
          <div class="ui-g-5"></div>
          <div class="ui-g-7">
            <button pButton class="p-button-success inline-block m-r-15"
                    type="submit"
                    [label]="'WS_DIRECTORY.SAVE' | translate"></button>
            <button pButton class="p-button-secondary inline-block"
                    type="button"
                    [label]="'WS_DIRECTORY.DISCARD' | translate" (click)="discard()"></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
